import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';

import styles from '../styles.module.scss';

const TimeValues = ({ children, calculateFunction, duration, currentTime }) => {
	const checkDuration = duration && !_.isNaN(duration);
	return (
		<>
			<div className={styles.currentTime}>{calculateFunction(currentTime)}</div>
			{children}
			<div className={styles.duration}>
				{(checkDuration && calculateFunction(duration)) || ''}
			</div>
		</>
	);
};

TimeValues.propTypes = {
	children: PropTypes.element.isRequired,
	calculateFunction: PropTypes.func.isRequired,
	duration: PropTypes.number.isRequired,
	currentTime: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default TimeValues;
